module.exports = __webpack_public_path__ + "media/img/frontend_application/myhosting/site_visit-65c1e4618dba1a4319a8bf7d554dbe24.png";